// extracted by mini-css-extract-plugin
export default {"sloganContainer":"SloganContainer_sloganContainer__it8m7"};